import * as React from 'react';
import { Provider as MobxProvider, inject } from 'mobx-react';

export const MobxContext = React.createContext(null as any);
const MobxInterceptorProvider = inject((stores) => ({ stores }))(
  ({ stores, children }) => {
    return (
      <MobxContext.Provider value={stores}>{children}</MobxContext.Provider>
    );
  },
);

export const useStores = () => React.useContext(MobxContext);

export const ContactsMobxProvider = React.memo((props) => {
  return (
    <MobxProvider {...props}>
      <MobxInterceptorProvider>{props.children}</MobxInterceptorProvider>
    </MobxProvider>
  );
});
